import { useFavorites } from '@/hooks/useFavorites';
import { Toast, useToast } from '@/components/feature/Toast';

interface DetailActionsProps {
  mediaId: string;
  title: string;
}

export default function DetailActions({ mediaId, title }: DetailActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const { message, showToast } = useToast();
  const favorited = isFavorite(mediaId);

  const handleFavorite = () => {
    const next = toggleFavorite(mediaId);
    showToast(next ? `已收藏《${title}》` : '已取消收藏');
  };

  const handleShare = async () => {
    const url = typeof window !== 'undefined' ? window.location.href : '';
    try {
      if (navigator.clipboard && url) {
        await navigator.clipboard.writeText(url);
        showToast('播放链接已复制，快去分享吧');
      } else {
        showToast('复制失败，请手动复制地址栏链接');
      }
    } catch {
      showToast('复制失败，请手动复制地址栏链接');
    }
  };

  return (
    <>
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={handleFavorite}
          className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-medium transition-colors ${
            favorited
              ? 'bg-accent-500 text-background-50 hover:bg-accent-600'
              : 'border border-background-300/70 bg-background-100/70 text-foreground-800 hover:bg-background-200'
          }`}
        >
          <i className={favorited ? 'ri-bookmark-fill' : 'ri-bookmark-line'}></i>
          {favorited ? '已收藏' : '收藏'}
        </button>
        <button
          type="button"
          onClick={handleShare}
          className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-100/70 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
        >
          <i className="ri-share-forward-line"></i>
          分享
        </button>
      </div>
      <Toast message={message} />
    </>
  );
}